module.exports = __webpack_public_path__ + "static/media/royal-gaming.861ad5fd.webp";